import axios, {estimation} from "./api"
import isEmpty from "lodash/isEmpty";

export const npcApi = {
    getNpcById(request) {
        const npc_id = request.npc_id;
        return axios.get(`/api/npc/${npc_id}`);
    },
    generateNpc(request, estimate = false, title, estimateCallback = null) {
        console.log('generateNpc', request)
        const data = {
            name: !isEmpty(request.name) ? request.name : '',
            influence: !isEmpty(request.influence) ? request.influence : '',
            proficiency: !isEmpty(request.proficiency) ? request.proficiency : '',
            equipment_level: !isEmpty(request.equipmentLevel) ? request.equipmentLevel : '',
            style: !isEmpty(request.style) ? request.style : 'realistic', // Note: Make this optional
            edition: !isEmpty(request.edition) ? request.edition : '5e', // Note: Make this optional
        }
        return estimation('/api/npc/generate', data, estimate, title, estimateCallback);
    },
    updateNpc(request) {
        return axios.patch(`/api/npc/${request.npc_id}`, request);
    },
    getUsersNpcHistory(request) {
        return axios.get(`/api/npc/history?range_start=${request.rangeStart}&result_limit=${request.resultLimit}`);
    },
    postRegenerateIllustration(request, estimate = false, title, estimateCallback = null) {
        return estimation(`/api/npc/${request.npc_id}/regenerate-illustration`, request, estimate, title, estimateCallback);
    },
    postRequestCreatureModification(request, estimate = false, title, estimateCallback = null) {
        return estimation(`/api/npc/${request.npc_id}/request-modification`, request, estimate, title, estimateCallback);
    },
    patchNpcIllustration(request) {
        return axios.patch(`/api/npc/${request.npc_id}/change-illustration`, request);
    },
    postNpcSearch(request) {
        return axios.post(`/api/npc/search`, request);
    },
}
